var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfilmobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.855,
    height: 49.855,
    viewBox: "0 0 49.855 49.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M31.136,17.068A9.568,9.568,0,1,1,21.568,7.5,9.568,9.568,0,0,1,31.136,17.068Zm-4.784,0a4.784,4.784,0,1,1-4.784-4.784A4.784,4.784,0,0,1,26.352,17.068Z",
    transform: "translate(3.359 1.277)",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M26.427,1.5A24.927,24.927,0,1,0,51.355,26.427,24.927,24.927,0,0,0,26.427,1.5ZM6.032,26.427a20.313,20.313,0,0,0,4.324,12.559,20.4,20.4,0,0,1,32.291-.19A20.4,20.4,0,1,0,6.032,26.427Zm20.4,20.4a20.311,20.311,0,0,1-12.853-4.559,15.868,15.868,0,0,1,25.894-.154A20.313,20.313,0,0,1,26.427,46.822Z",
    transform: "translate(-1.5 -1.5)",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilmobile);
export default __webpack_public_path__ + "static/media/profilmobile.760fa65110953c959f20846e1ef0a8d1.svg";
export { ForwardRef as ReactComponent };